module.exports = __webpack_public_path__ + "img/canbadge_rectangle_yoko_line.0f07e338.png";